// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fullsize[data-v-f10f08bc]{width:100%;height:100%;min-height:100%;border-radius:inherit;display:flex}", ""]);
// Exports
module.exports = exports;
